module.exports = __webpack_public_path__ + "static/img/kb-card-img-04@w.d894142.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/kb-card/kb-card-img-04@w.jpg
// module id = Sz6H
// module chunks = 0